<script>
import ContentInfinityScrollView from '@/components/common/content/ContentInfinityScrollView'
import {ApiPaginatedAccumulatedData} from '@/assets/js/api/_helpers'
import api from '@/assets/js/api'
import ControlsPurchasesListItem from '@/components/requests/controls/purchases/list/ControlsPurchasesListItem'

export default {
  extends: ContentInfinityScrollView,

  props: {
    accountId: Number,
  },

  data() {
    return {
      apiData: new ApiPaginatedAccumulatedData(api.requests.controls.purchases.list),
      listItem: {
        component: ControlsPurchasesListItem,
      }
    }
  },

  computed: {
    groups() {
      return this.getGroupsByDate('purchased_at')
    }
  },

  watch: {
    'accountId': {
      deep: true,
      handler() {
        this.$nextTick(() => this.reload())
      }
    }
  },
}
</script>